<div class="my_order_details my_order_sec my_secondhandsupplies_orderdetails_sec">
  <div class="order_main" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
    fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="15px">
    <div class="column order_one" fxLayout="column" fxFlex.xl="70" fxFlex.lg="70" fxFlex.md="70" fxFlex.sm="70"
      fxFlex.xs="100" fxFlexFill>
      <div class="order_details_left">
        <!-- order_box -->
        <div class="order_box">
          <div class="order_row" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
            fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="15px">
            <div fxLayout="column" fxFlex.xl="100" fxFlex.lg="100" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100"
              fxFlexFill>
              <div class="order_flex">
                <div>
                  <h4 class="primary">Order Id : {{oldSecondHandSuppliesOrders.order_number}}</h4>
                  <p class="order_date">Order at : {{oldSecondHandSuppliesOrders.created_at | date: 'dd/MM/yyyy'}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="address_row_box">
            <div class="row-wrap shipping_data" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row"
              fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="end end">
              <div class="shipping_data_col" fxLayout="column" fxFlex.xl="50" fxFlex.lg="50" fxFlex.md="50"
                fxFlex.sm="50" fxFlex.xs="100" fxFlexFill>
                <div class="address_box">
                  <h4>Shipping address :</h4>
                  <div class="media">
                    <div class="media-left">
                      <img src="../../../../../assets/images/icons/address.jpg" alt="">
                    </div>
                    <div class="media-body">
                      <p *ngIf="oldSecondHandSuppliesOrders?.billing_address?.short_name">
                        {{oldSecondHandSuppliesOrders?.billing_address?.short_name}},</p>
                      <p *ngIf="oldSecondHandSuppliesOrders?.billing_address?.line_1">
                        {{oldSecondHandSuppliesOrders?.billing_address?.line_1}}</p>
                      <p
                        *ngIf="oldSecondHandSuppliesOrders?.billing_address?.line_2 && oldSecondHandSuppliesOrders?.billing_address?.landmark">
                        {{oldSecondHandSuppliesOrders?.billing_address?.line_2}},
                        {{oldSecondHandSuppliesOrders?.billing_address?.landmark}}</p>
                      <p
                        *ngIf="oldSecondHandSuppliesOrders?.billing_address?.city && oldSecondHandSuppliesOrders?.billing_address?.state && oldSecondHandSuppliesOrders?.billing_address?.country">
                        {{oldSecondHandSuppliesOrders?.billing_address?.city}},
                        {{oldSecondHandSuppliesOrders?.billing_address?.state}},{{oldSecondHandSuppliesOrders?.billing_address?.country}}
                      </p>
                      <p *ngIf="oldSecondHandSuppliesOrders?.billing_address?.postal_code">
                        {{oldSecondHandSuppliesOrders?.billing_address?.postal_code}}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="shipping_data_col" fxLayout="column" fxFlex.xl="50" fxFlex.lg="50" fxFlex.md="50"
                fxFlex.sm="50" fxFlex.xs="100" fxFlexFill>
                <div class="address_box customer_info" *ngIf="oldSecondHandSuppliesOrders.dental_practice">
                  <h4>Customer Info</h4>
                  <p>{{oldSecondHandSuppliesOrders.dental_practice.name}}</p>
                  <p>{{oldSecondHandSuppliesOrders.dental_practice.phone}}</p>
                  <p>{{oldSecondHandSuppliesOrders.dental_practice.email}}</p>
                </div>
                <div class="address_box customer_info" *ngIf="oldSecondHandSuppliesOrders.dental_professional">
                  <h4>Customer Info</h4>
                  <p>{{oldSecondHandSuppliesOrders.dental_professional.name}}</p>
                  <p>{{oldSecondHandSuppliesOrders.dental_professional.phone}}</p>
                  <p>{{oldSecondHandSuppliesOrders.dental_professional.email}}</p>
                </div>
                <div class="address_box customer_info" *ngIf="oldSecondHandSuppliesOrders.dental_supplier">
                  <h4>Customer Info</h4>
                  <p>{{oldSecondHandSuppliesOrders.dental_supplier.name}}</p>
                  <p>{{oldSecondHandSuppliesOrders.dental_supplier.phone}}</p>
                  <p>{{oldSecondHandSuppliesOrders.dental_supplier.email}}</p>
                </div>
                <div class="address_box customer_info" *ngIf="oldSecondHandSuppliesOrders.second_hand_supply">
                  <h4>Supplier Info</h4>
                  <ng-container *ngIf="oldSecondHandSuppliesOrders.second_hand_supply?.dental_supplier">
                    <p>{{oldSecondHandSuppliesOrders.second_hand_supply?.dental_supplier?.business_name}}</p>
                    <p>{{oldSecondHandSuppliesOrders.second_hand_supply?.dental_supplier?.phone}}</p>
                    <p>{{oldSecondHandSuppliesOrders.second_hand_supply?.dental_supplier?.email}}</p>
                  </ng-container>
                  <ng-container *ngIf="oldSecondHandSuppliesOrders.second_hand_supply?.dental_professional">
                    <p>{{oldSecondHandSuppliesOrders.second_hand_supply?.dental_professional?.name}}</p>
                    <p>{{oldSecondHandSuppliesOrders.second_hand_supply?.dental_professional?.phone}}</p>
                    <p>{{oldSecondHandSuppliesOrders.second_hand_supply?.dental_professional?.email}}</p>
                  </ng-container>
                  <ng-container *ngIf="oldSecondHandSuppliesOrders.second_hand_supply?.dental_practice">
                    <p>{{oldSecondHandSuppliesOrders.second_hand_supply?.dental_practice?.name}}</p>
                    <p>{{oldSecondHandSuppliesOrders.second_hand_supply?.dental_practice?.phone}}</p>
                    <p>{{oldSecondHandSuppliesOrders.second_hand_supply?.dental_practice?.email}}</p>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
          <!-- WEB-TRACK -->
          <!-- <div class="order_track web_order_track" fxLayoutAlign="center center" fxShow="true" fxShow.lt-sm="false">
            <ul>
              <li class="completed" *ngFor="let singleUpdate of oldSecondHandSuppliesOrders.supplies_order_notes">
                <span class="circles" [ngClass]="singleUpdate?.status"></span>
                <span class="bar"></span>
                <h4>{{singleUpdate.status}}</h4>
                <span class="time">
                  {{singleUpdate.created_at | date: 'dd-MM-yyyy hh:mm:ss'}}
                </span>
              </li>
            </ul>
          </div> -->
          <!-- MOBILE-TRACK -->
          <div class="mobile_order_track">
            <div class="order-track" [@openCloseStatus]="openStatus ? true : false">
              <div class="order-track-step"
                *ngFor="let singleUpdate of oldSecondHandSuppliesOrders.second_hand_supplies_order_notes">
                <div class="order-track-status">
                  <span class="order-track-status-dot" [ngClass]="singleUpdate?.status"></span>
                  <span class="order-track-status-line"></span>
                </div>
                <div class="order-track-text">
                  <p class="order-track-text-stat">{{singleUpdate.status}}</p>
                  <span class="order-track-text-sub">{{singleUpdate.created_at | date: 'dd-MM-yyyy hh:mm:ss'}}</span>
                </div>
              </div>
            </div>
            <div class="view_all_status"
              *ngIf="oldSecondHandSuppliesOrders.second_hand_supplies_order_notes.length >= 3">
              <a (click)="filterToggleStatus()">View all status</a>
            </div>
          </div>
        </div>
        <!-- ORDER-ITEM-LIST -->
        <div class="order_items_listing order-product-listing">
          <ul>
            <li>
              <div class="cart_box_li">
                <div class="media">
                  <div class="media-left">
                    <img [src]="oldSecondHandSuppliesOrders?.second_hand_supply?.image?.url" class="media-object">
                  </div>
                  <div class="media-body">
                    <!-- <h4 class="media-heading">{{oldSecondHandSuppliesOrders.second_hand_supply.title}}</h4> -->
                    <div class="media-heading">
                      <div class="order_meida_flexleft">
                        <p class="product___title"> {{oldSecondHandSuppliesOrders.second_hand_supply.title}}</p>
                      </div>
                      <div class="price">
                        <span class="price_overall">
                          AUD {{oldSecondHandSuppliesOrders.sub_total.toFixed(2)}}
                        </span>
                      </div>
                    </div>
                    <!-- custom_form_group -->
                    <div class="custom_form_group">
                      <label for="" class="custom_label">Quantity<span class="dots">:</span></label>
                      <p class="value">1</p>
                    </div>
                    <!-- custom_form_group -->
                    <!-- <div class="custom_form_group">
                      <label for="" class="custom_label">Price<span class="dots">:</span></label>
                      <p class="value">AUD {{oldSecondHandSuppliesOrders.sub_total.toFixed(2)}}</p>
                    </div> -->
                    <!-- custom_form_group -->
                    <div class="custom_form_group" *ngIf="oldSecondHandSuppliesOrders?.second_hand_supply?.color">
                      <label for="" class="custom_label">Color<span class="dots">:</span></label>
                      <p class="value">
                        <span class="colorBox"
                          [ngStyle]="{'background-color': oldSecondHandSuppliesOrders?.second_hand_supply?.color, 'border-color': oldSecondHandSuppliesOrders?.second_hand_supply?.color }">
                        </span>
                      </p>
                    </div>
                    <!-- <div *ngIf="oldSecondHandSuppliesOrders?.second_hand_supply?.color">
                    <span> Color :
                      <span class="colorBox"
                      [ngStyle]="{'background-color': oldSecondHandSuppliesOrders?.second_hand_supply?.color, 'border-color': oldSecondHandSuppliesOrders?.second_hand_supply?.color }">
                      </span>
                  </span>
                  </div> -->
                  </div>
                </div>
                <!-- <div class="price">
                  <p class="new_price">AUD {{oldSecondHandSuppliesOrders.sub_total.toFixed(2)}}</p>
                </div> -->
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="column order_one" fxLayout="column" fxFlex.xl="30" fxFlex.lg="30" fxFlex.md="30" fxFlex.sm="30"
      fxFlex.xs="100" fxFlexFill>
      <div class="order_details_right">
        <div class="total-cost-box">
          <div class="total-cost">
            <span class="total-text">Subtotal</span>
            <span class="total-price">
              AUD {{oldSecondHandSuppliesOrders.sub_total.toFixed(2)}}
            </span>
          </div>
          <div class="total-cost">
            <span class="total-text"> Freight Charges </span>
            <span class="total-price">
              AUD {{oldSecondHandSuppliesOrders.delivery_charge.toFixed(2)}}
            </span>
          </div>
          <div class="total-cost">
            <span class="total-text">GST</span>
            <span class="total-price">
              AUD {{oldSecondHandSuppliesOrders.tax_amount.toFixed(2)}}
            </span>
          </div>
          <div class="total-cost">
            <span class="total-text">Total Amount</span>
            <span class="total-price">
              AUD {{oldSecondHandSuppliesOrders.total_amount.toFixed(2)}}
            </span>
          </div>
          <div class="support_btns">
            <button type="button" class="btn btn-sm global-btn support_btn" mat-button (click)="supportRequestDialog()">
              Support</button>
            <button type="button" class="btn btn-sm global-btn support_btn" mat-button (click)="viewInvoice()"
              *ngIf="oldSecondHandSuppliesOrders.status === 'DELIVERED'">
              View Invoice </button>
          </div>
        </div>
      </div>
      <div class="delivery_notes mt-20">
        <div class="head">
          <h4>Delivery Note</h4>
        </div>
        <ul>
          <li *ngFor="let singleNote of oldSecondHandSuppliesOrders?.second_hand_supplies_order_notes">
            <div class="notes_content">
              <p>{{singleNote.message}} </p>
              <p *ngIf="singleNote?.extra?.tracking_number">Tracking Number: {{singleNote?.extra?.tracking_number}} </p>
              <p *ngIf="singleNote?.extra?.freight_company_name">{{singleNote?.extra?.freight_company_name}} </p>
              <div class="flex_btns_track">
                <p *ngIf="singleNote?.extra?.invoice?.url">
                  <a target="_blank" [href]="singleNote?.extra?.invoice?.url">View
                    and Download Invoice </a>
                </p>
                <p *ngIf="singleNote?.extra?.tracking_link">
                  <a target="_blank" [href]="singleNote?.extra?.tracking_link">Track </a>
                </p>
              </div>
            </div>
            <p class="status">Status : {{singleNote.created_at |date: 'dd-MM-yyyy hh:mm:ss' }}, {{singleNote.status}}
            </p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
